import { getReq } from '../../utils/request'
import { IDashboardCompletedJobsByHour } from '../../reducers/dashboard/actions'

const fetchDashboardCompletedJobsByHour = async (weeksBack: number = 0) => {
	const { data } = await getReq('/api/admin/dashboard/week/completed-jobs-by-hour', {
		weeksBack
	})

	return data as IDashboardCompletedJobsByHour
}

export default fetchDashboardCompletedJobsByHour
